import React from "react";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import ApproveGatepass from "./ApproveGatepass";
import ClaimGatepass from "./ClaimGatepass";
import type { GatepassFlowData } from "./ClaimGatepass";
import PrintGatepass from "./PrintGatepass";
import RejectGatepass from "./RejectGatepass";
import UnclaimGatepass from "./UnclaimGatepass";
import { canShowFlowButtonsForUser, canUserClaim, GATEPASS_STATUSES } from "./utils";

interface GatepassFlowButtonsProps {
  openDrawer: (drawerName: string) => void;
  gatepassFlowData?: GatepassFlowData;
  onPrint?: () => void;
}

const GatepassFlowButtons: React.FC<GatepassFlowButtonsProps> = ({
  gatepassFlowData,
  openDrawer,
  onPrint,
}) => {
  const userCompanyId = useAuthStore((s) => s.user?.companyId ?? null);
  const showFlowButtons =
    gatepassFlowData?.status &&
    gatepassFlowData?.task?.role &&
    canShowFlowButtonsForUser(
      gatepassFlowData.status,
      gatepassFlowData.task.role,
      userCompanyId,
      gatepassFlowData.sponsorCompany,
    );

  const isClaimOnly =
    showFlowButtons &&
    gatepassFlowData?.task &&
    canUserClaim(
      gatepassFlowData.task.status,
      gatepassFlowData.status,
      gatepassFlowData.task.role,
      gatepassFlowData.task.claimOwnerName,
    );
  const canPrintGatepass =
    gatepassFlowData?.status === GATEPASS_STATUSES.APPROVED ||
    gatepassFlowData?.status === GATEPASS_STATUSES.EXPIRED;

  return (
    <div className="flex gap-4 mb-4">
      {showFlowButtons && (
        <>
          {isClaimOnly ? (
            <>
              {canPrintGatepass && (
                <PrintGatepass gatepassFlowData={gatepassFlowData} onPrint={onPrint} />
              )}
              <ClaimGatepass gatepassFlowData={gatepassFlowData} />
            </>
          ) : (
            <>
              <UnclaimGatepass gatepassFlowData={gatepassFlowData} />
              {canPrintGatepass && (
                <PrintGatepass gatepassFlowData={gatepassFlowData} onPrint={onPrint} />
              )}
              <RejectGatepass gatepassFlowData={gatepassFlowData} openDrawer={openDrawer} />
              <ApproveGatepass gatepassFlowData={gatepassFlowData} openDrawer={openDrawer} />
            </>
          )}
        </>
      )}
      {!showFlowButtons && canPrintGatepass && (
        <PrintGatepass gatepassFlowData={gatepassFlowData} onPrint={onPrint} />
      )}
    </div>
  );
};

export default GatepassFlowButtons;
